import { ColorGroup } from '~/lib/color'
import { wrapIfPresent } from '~/lib/wrapIfPresent'

export const getCoordinateImageAlt = ({
  nickName,
  brandName,
  brandNameKana,
  itemName,
  categoryName,
  colorName,
  seasonName,
  genderName,
  height,
  bodyFrameTypeName,
  generationName,
  tagNames,
}: {
  nickName: string
  brandName?: string
  brandNameKana?: string
  itemName?: string
  categoryName?: string
  colorName?: ColorGroup
  seasonName?: '春' | '夏' | '秋' | '冬'
  genderName?: string
  height?: number
  bodyFrameTypeName?: string
  generationName?: string
  tagNames?: string[]
}) => {
  const tagText = wrapIfPresent('「', tagNames?.join('、'), '」｜')

  const brandKana = wrapIfPresent('（', brandNameKana, '）')
  const brandText = brandName ? `${brandName}${brandKana}の` : ''

  const itemDetailsText = wrapIfPresent(
    '（',
    [categoryName, colorName].filter(Boolean).join('、'),
    '）'
  )
  const itemText = itemName
    ? `${itemName}${itemDetailsText}`
    : brandText || itemDetailsText
      ? `アイテム${itemDetailsText}`
      : ''
  const itemAndBrandText = wrapIfPresent(
    '「',
    `${brandText}${itemText}`,
    '」を使った、'
  )

  const userInformationText = wrapIfPresent(
    '（',
    [
      bodyFrameTypeName,
      genderName,
      height ? `${height}cm` : undefined,
      generationName,
    ]
      .filter(Boolean)
      .join('・'),
    '）'
  )

  return `${tagText}${itemAndBrandText}${nickName}さん${userInformationText}の${seasonName ?? ''}コーディネート`
}
